/**
 * ドライバースケジュール
 * ドライバー設定
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const driver_schedule_driver_setting = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 編集項目の取得
     * @param commit
     * @param order_id
     * @returns {Promise<unknown>}
     */
    edit ({ commit }, { order_id }) {
      const api_path = `${httpConst.DRIVER_ENDPOINT}/driver_schedules/driver_settings/${order_id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 編集内容の更新
     * @param commit
     * @param order_id
     * @param params
     * @returns {Promise<unknown>}
     */
    update ({ commit }, { order_id, params }) {
      const api_path = `${httpConst.DRIVER_ENDPOINT}/driver_schedules/driver_settings/${order_id}`
      return new Promise((resolve) => {
        Vue.$http.put(api_path, params).then(data => {
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
}

export default driver_schedule_driver_setting
